module.exports = __webpack_public_path__ + "img/airplane_selected.3c0552a7.png";